import {useSelector, useDispatch} from 'react-redux';

import Globals from '../../constants/Globals';

import {useDrop} from 'react-dnd';

import {Button, Card} from 'react-bootstrap';

import {
  filterTasksByJobAndDate,
  selectTasks, sortTasksForCalendar
} from '../../features/tasks';
import CalendarTask from '../employee-calendar/calendar-task';
import {selectSettings} from '../../features/settings';
import {hasFinePointer} from '../../utils/device-utils';

const CalendarDay = (props) => {
  const dispatch = useDispatch();

  const settings = useSelector(selectSettings);

  const jobId = props.job.uid;

//  const [hoursCount, setHoursCount] = useState(0);

  const dateString = props.date.toISOString().split('T')[0];

  const tasks = sortTasksForCalendar(
      filterTasksByJobAndDate(useSelector(selectTasks), jobId, dateString));

//  const effortCount = countEffortByUserAndDate(tasks, jobId, dateString);

  const taskItems = [];

  for (const task of tasks) {
    taskItems.push(<CalendarTask key={task.uid} task={task} date={props.date} mode="job"/>);
  }

  const allowedDropEffect = 'any';

  function addTask() {
    dispatch({
      type: 'ui/setModalState',
      payload: {
        name: 'newTask',
        value: true,
        params: {mode: 'new', date: dateString, job: jobId}
      }
    });
  }

  function onDayDoubleClick(event) {
    /* nur auf der leeren Fläche, nicht auf Aufgaben oder Button */
    if (event.target !== event.currentTarget) {
      return;
    }

    if (!hasFinePointer()) {
      return;
    }

    addTask();
  }

  function selectBackgroundColor(isActive, canDrop) {
    if (isActive) {
      return 'rgba(0, 255, 0, 0.2)';
    } else if (canDrop) {
      return 'rgba(0, 255, 0, 0.1)';
    } else {
      return '#fff';
    }
  }

  const [{canDrop, isOver}, drop] = useDrop(
      () => ({
        accept: Globals.ITEM_TYPES.CARD,
        drop: () => ({
          date: dateString,
          jobId: jobId,
          allowedDropEffect
        }),
        collect: (monitor) => ({
          isOver: monitor.isOver(),
          canDrop: monitor.canDrop()
        })
      }),
      [allowedDropEffect, dateString, jobId]
  );
  const isActive = canDrop && isOver;
  const backgroundColor = selectBackgroundColor(isActive, canDrop);

  // const boxShadow = selectBoxShadow(
  //     (effortCount > user.workingHoursPerDay && props.showHoursCount));

  return (
      <Card ref={drop} onDoubleClick={onDayDoubleClick} style={{
        backgroundColor: backgroundColor,
        width: settings.cardWidth + 'px',
        minHeight: '120px',
        paddingBottom: '60px',
        flex: 'auto',
        flexGrow: 0
        // boxShadow: boxShadow
      }}>
        {taskItems}

        <Button variant="outline-primary btn-sm" style={{
          position: 'absolute',
          right: '4px',
          bottom: '4px',
          width: '31px'
        }} onClick={addTask}>+</Button>
      </Card>
  );
};

export default CalendarDay;
